

export const config = {
    apiurl:"https://homeplanner.energeek.tech/api"
} 
